<template>
  <div class="inbox" v-loading="loading">
    <div class="operation-btn">
      <button @click="$router.back()">返回</button>
      <button @click="goToEmail(1)">回复</button>
      <button @click="goToEmail(2)">转发</button>
    </div>
    <div class="title-box">
      <p class="title">{{ emailBody.subject }}</p>
      <p class="mt10"><span class="receInfo">发件人：</span>{{ emailBody.from }}</p>
      <p class="mt10"><span class="receInfo">时间：</span>{{ emailBody.sendDate }}</p>
      <p class="mt10"><span class="receInfo">收件人：</span>{{ emailBody.to }}</p>
      <p class="mt10" v-if="emailBody.multipart">
        <span class="receInfo">附件：</span>
        <span>
          <img src="@/assets/images/oa_mail_link.png" class="vm" />
        </span>
        <span style="cursor: pointer">
          <span v-for="(item, index) in emailBody.attachments" :key="index" @click="download(item.fileName)">
            {{ item.fileName }}
          </span></span
        >
      </p>
    </div>
    <div class="content-box" :style="contentWidth">
      <div class="content" v-html="emailBody.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "inbox",
  data() {
    return {
      loading: true,
      emailBody: {}, // 邮件内容详情
      contentWidth: "", // 显示内容的宽度
    };
  },
  methods: {
    /**
     * 跳转到写邮件页面
     */
    goToEmail(type) {
      this.$router.push({
        path: "/email",
        query: {
          type: type,
          folderId: this.$route.query.folderId,
          id: this.$route.query.id,
        },
      });
    },
    /**
     * 获取邮件详情
     */
    getDetail() {
      this.loading = true;
      let folderId = this.$route.query.folderId;
      let id = this.$route.query.id;
      this.$api.getEmailDetail(folderId, id, {
        onSucess: (res) => {
          if (res.data.errcode == 0) {
            this.loading = false;
            this.emailBody = {
              ...res.data.data.emailBody,
              sendDate: this.formDate(res.data.data.emailBody.sendDate),
            };
          }
        },
      });
    },

    /**
     *  下载文件
     */
    download(fileName) {
      this.loading = true;
      let folderId = this.$route.query.folderId;
      let id = this.$route.query.id;
      this.$api.downloadFile(folderId, id, fileName, {
        onSucess: (response) => {
          this.loading = false;
          this.getOutExcel(fileName, response.data);
        },
      });
    },

    /**
     * 二进制数据流转xls
     */
    getOutExcel(fileName, res) {
      let blob = new Blob([res], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        //兼容 IE & EDGE
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        // 兼容不同浏览器的URL对象
        const url = window.URL || window.webkitURL || window.moxURL;
        // 创建下载链接
        link.href = url.createObjectURL(blob);
        //命名下载名称
        link.download = fileName;
        //点击触发下载
        link.click();
        //下载完成进行释放
        url.revokeObjectURL(link.href);
      }
    },

    /**
     * 格式化时间
     */
    formDate(value) {
      let date = new Date(value);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + date.getMonth() + 1;
      let day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();
      let hour = date.getHours() >= 10 ? date.getHours() : "0" + date.getHours();
      let minute = date.getMinutes() >= 10 ? date.getMinutes() : "0" + date.getMinutes();
      let second = date.getSeconds() >= 10 ? date.getSeconds() : "0" + date.getSeconds();
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },
  },
  mounted() {
    setTimeout(() => {
      let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //220 左侧 aside  40 padding
      this.contentWidth = clientWidth - 220 - 40 + "px";
    }, 100);
    this.getDetail();
  },
};
</script>
